import { render, staticRenderFns } from "./TkFlightPrice.vue?vue&type=template&id=7808eed6&scoped=true&"
import script from "./TkFlightPrice.vue?vue&type=script&lang=js&"
export * from "./TkFlightPrice.vue?vue&type=script&lang=js&"
import style0 from "./TkFlightPrice.vue?vue&type=style&index=0&id=7808eed6&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7808eed6",
  null
  
)

export default component.exports